module.exports = __webpack_public_path__ + "assets/img/11.0d75d4e2.png";